import { isDebugEnabled } from '@euler/functions/debug';
import {
  kDefaultReportSharingLogStore,
  useReportSharingLogManager,
  useReportSharingLogStore$,
} from '@euler/functions/sharing/useReportSharingLogs';
import { makeDebug } from '@euler/utils';
import { memo, useEffect } from 'react';
import { AppState } from 'react-native';
import { filter } from 'rxjs';

const debug = makeDebug('report-sharing-logs', isDebugEnabled('shareReport'));

export const FlushReportSharingLogs = memo(() => {
  const { flushLogs } = useReportSharingLogManager();
  const store$ = useReportSharingLogStore$();

  useEffect(() => {
    // always flush at app launch
    store$
      .pipe(filter(x => x !== kDefaultReportSharingLogStore))
      .subscribe(store => {
        debug('flush logs on app launch: %O', store);
        void flushLogs();
      });

    const listener = AppState.addEventListener('change', state => {
      if (state === 'active') {
        void flushLogs();
      }
    });

    return () => {
      listener.remove();
    };
  }, [flushLogs, store$]);

  return null;
});
